import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '@app/@shared';
import { DashboardApiService } from './services/dashboard.api.service';
import { DashboardDateTabsComponent } from './components/dashboard-date-tabs/dashboard-date-tabs.component';
import { DashboardOverviewPanelComponent } from './components/dashboard-overview-panel/dashboard-overview-panel.component';
import { DashboardMerchantTableComponent } from './components/dashboard-merchant-table/dashboard-merchant-table.component';
import { DashboardIncomeChartComponent } from './components/dashboard-income-chart/dashboard-income-chart.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    DashboardDateTabsComponent,
    DashboardOverviewPanelComponent,
    DashboardMerchantTableComponent,
    DashboardIncomeChartComponent,
  ],
  providers: [DashboardApiService],
})
export class DashboardModule {}
